import {
  Outlet,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { TermsOfServiceDialog } from './TermsOfServiceDialog';
import { MediaTypeTab } from './MediaTypeTab';

export const MediaCenter = () => {
  const navigate = useNavigate();
  const { listingKey } = useParams();
  const [searchParams] = useSearchParams();

  // LM-1810: Skip Media Center TOU if user already accepted via Media Sync.
  // The MSaaS plugin passes this query param when navigating here after consent.
  const [isTOSModalOpen, setIsTOSModalOpen] = useState(
    searchParams.get('media_center_terms_accepted') !== 'true',
  );
  const [isTOSModalFromUserOpen, setIsTOSModalFromUserOpen] = useState(false);

  const handleAlertClose = () => {
    setIsTOSModalOpen(false);
  };

  const handleAlertCloseAndReturn = () => {
    navigate(`/edit/${listingKey}`, { state: { from: 'media' } });
  };

  return (
    <Box sx={{ width: '100%', px: 4 }}>
      <Button
        className="bmls_btn"
        sx={{ mt: 2, textTransform: 'none', pl: 0 }}
        onClick={() =>
          navigate(`/edit/${listingKey}`, { state: { from: 'media' } })
        }
      >
        <Typography
          sx={{
            fontSize: '.8rem',
            fontWeight: 'bold',
            color: 'secondary.medium',
          }}
        >
          Return to edit form
        </Typography>
      </Button>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          mt: 2,
        }}
      >
        <Typography sx={{ fontSize: '1.6rem' }}>Media Center</Typography>
        <Button
          className="bmls_btn"
          sx={{ textTransform: 'none' }}
          onClick={() => setIsTOSModalFromUserOpen(true)}
        >
          <Typography
            sx={{
              fontSize: '.8rem',
              fontWeight: 'bold',
              color: 'secondary.medium',
            }}
          >
            View Terms Of Use
          </Typography>
        </Button>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          borderRadius: 2,
          backgroundColor: 'grey.50',
          p: 1,
          mx: { xs: -1, sm: 0 },
          my: 2,
          width: 'fit-content',
          gap: { xs: 0.25, sm: 1 },
        }}
      >
        <MediaTypeTab to="photos" label="Photos" />
        <MediaTypeTab to="documents" label="Documents" />
        <MediaTypeTab to="tours" label="Virtual Tours" />
      </Box>

      <Outlet />

      <TermsOfServiceDialog
        open={isTOSModalOpen}
        onAccept={handleAlertClose}
        onDecline={handleAlertCloseAndReturn}
        showActions
      />

      <TermsOfServiceDialog
        open={isTOSModalFromUserOpen}
        onClose={() => setIsTOSModalFromUserOpen(false)}
        showActions={false}
      />
    </Box>
  );
};
